import CardAuthorBox from "components/CardAuthorBox/CardAuthorBox";
import CardAuthorBox2 from "components/CardAuthorBox2/CardAuthorBox2";
import Heading from "components/Heading/Heading";
import { AuthorType } from "data/types";
import React, { FC, useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface SectionGridAuthorBoxProps {
  className?: string;
  authors?: AuthorType[];
  headingText?: string;
  boxCard?: "box1" | "box2";
  gridClassName?: string;
}

const SectionGridAuthorBox: FC<SectionGridAuthorBoxProps> = ({
  className = "",
  authors = [],
  headingText = "Top Business of the month",
  boxCard = "box1",
  gridClassName = "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4",
}) => {
  const nextRef = useRef<HTMLButtonElement | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`nc-SectionGridAuthorBox relative ${className}`}
      data-nc-id="SectionGridAuthorBox"
    >
      <Heading desc="Rating based on customer reviews" isCenter>
        {headingText}
      </Heading>

      {authors.length > 0 ? (
        <>
          {isMobile ? (
            <div>
              <Swiper
                spaceBetween={10}
                slidesPerView={1.3}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                modules={[Autoplay, Navigation]}
                loop={true}
                style={{ paddingRight: "10px" }}
                navigation={{
                  nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper: SwiperType) => {
                  if (
                    swiper.params.navigation &&
                    typeof swiper.params.navigation !== "boolean"
                  ) {
                    swiper.params.navigation.nextEl = nextRef.current;
                  }
                }}
              >
                {authors.map((author, index) => (
                  <SwiperSlide key={author.id}>
                    {boxCard === "box2" ? (
                      <CardAuthorBox2 author={author} />
                    ) : (
                      <CardAuthorBox
                        index={index < 3 ? index + 1 : undefined}
                        author={author}
                      />
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
              <button
                ref={nextRef}
                className="absolute top-[72.5%] -translate-y-1/2 right-[-10px] z-10 w-10 h-10 bg-dry border border-textGray rounded-full shadow flex items-center justify-center"
              >
                <ArrowRightIcon className="w-5 h-5 text-red-500 ml-0" />
              </button>
            </div>
          ) : (
            <div className={`grid gap-6 md:gap-8 ${gridClassName}`}>
              {authors.map((author, index) =>
                boxCard === "box2" ? (
                  <CardAuthorBox2 key={author.id} author={author} />
                ) : (
                  <CardAuthorBox
                    index={index < 3 ? index + 1 : undefined}
                    key={author.id}
                    author={author}
                  />
                )
              )}
            </div>
          )}
        </>
      ) : (
        <div className="mt-12 text-center space-y-6">
          <p className="text-lg text-textGray mb-6">🔍 No data found</p>
          <a
            href="https://business.lokalai.com/intro"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ButtonPrimary
              className="mt-6"
              sizeClass="px-6 py-3 lg:px-8 lg:py-4 rounded-xl"
              fontSize="text-sm sm:text-base lg:text-lg font-medium"
            >
              List your Business
            </ButtonPrimary>
          </a>
        </div>
      )}

      <div className="border-b border-border mt-10 max-w-sm mx-auto"></div>
    </div>
  );
};

export default SectionGridAuthorBox;

// import CardAuthorBox from "components/CardAuthorBox/CardAuthorBox";
// import CardAuthorBox2 from "components/CardAuthorBox2/CardAuthorBox2";
// import Heading from "components/Heading/Heading";
// // import { DEMO_AUTHORS } from "data/authors";
// import { booking, business, loyalty } from "data/business";
// import { AuthorType } from "data/types";
// import React, { FC, useEffect, useState, useRef } from "react";
// import ButtonPrimary from "shared/Button/ButtonPrimary";
// import ButtonSecondary from "shared/Button/ButtonSecondary";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";
// import type { Swiper as SwiperType } from "swiper";
// import { FiArrowRight } from "react-icons/fi";

// import { ArrowRightIcon } from "@heroicons/react/24/solid";

// export interface SectionGridAuthorBoxProps {
//   className?: string;
//   authors?: AuthorType[];
//   authors2?: AuthorType[];
//   authors3?: AuthorType[];
//   boxCard?: "box1" | "box2";
//   gridClassName?: string;
// }

// const DEMO_DATA = business.filter((_, i) => i < 10);

// const SectionGridAuthorBox: FC<SectionGridAuthorBoxProps> = ({
//   className = "",
//   authors = DEMO_DATA,
//   authors2 = booking,

//   authors3 = loyalty,

//   boxCard = "box1",
//   gridClassName = "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 ",
// }) => {
//   const nextRef = useRef<HTMLButtonElement | null>(null);

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div
//       className={`nc-SectionGridAuthorBox relative ${className}`}
//       data-nc-id="SectionGridAuthorBox"
//     >
//       <Heading desc="Rating based on customer reviews" isCenter>
//         Top Business of the month
//       </Heading>

//       {authors.length > 0 ? (
//         <>
//           {isMobile ? (
//             <div>
//               <Swiper
//                 spaceBetween={10}
//                 slidesPerView={1.3} // Show 2 full + 0.3 of next
//                 autoplay={{ delay: 4000, disableOnInteraction: false }}
//                 modules={[Autoplay, Navigation]}
//                 loop={true}
//                 style={{ paddingRight: "10px" }}
//                 navigation={{
//                   nextEl: nextRef.current,
//                 }}
//                 onBeforeInit={(swiper: SwiperType) => {
//                   if (
//                     swiper.params.navigation &&
//                     typeof swiper.params.navigation !== "boolean"
//                   ) {
//                     swiper.params.navigation.nextEl = nextRef.current;
//                   }
//                 }}
//               >
//                 {authors.map((author, index) => (
//                   <SwiperSlide key={author.id}>
//                     {boxCard === "box2" ? (
//                       <CardAuthorBox2 author={author} />
//                     ) : (
//                       <CardAuthorBox
//                         index={index < 3 ? index + 1 : undefined}
//                         author={author}
//                       />
//                     )}
//                   </SwiperSlide>
//                 ))}
//               </Swiper>
//               <button
//                 ref={nextRef}
//                 className="absolute top-[72.5%] -translate-y-1/2 right-[-10px] z-10 w-10 h-10 bg-dry border border-textGray rounded-full shadow flex items-center justify-center"
//               >
//                 <span className="text-xl">
//                   <ArrowRightIcon className="w-5 h-5 text-red-500 ml-0" />
//                 </span>{" "}
//                 {/* You can use an icon here instead */}
//               </button>
//             </div>
//           ) : (
//             <div className={`grid gap-6 md:gap-8 ${gridClassName}`}>
//               {authors.map((author, index) =>
//                 boxCard === "box2" ? (
//                   <CardAuthorBox2 key={author.id} author={author} />
//                 ) : (
//                   <CardAuthorBox
//                     index={index < 3 ? index + 1 : undefined}
//                     key={author.id}
//                     author={author}
//                   />
//                 )
//               )}
//             </div>
//           )}

//           {/* <div className="mt-16 flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-5">
//         <ButtonSecondary>Show me more </ButtonSecondary>
//         <ButtonPrimary>List your Business</ButtonPrimary>
//       </div> */}
//         </>
//       ) : (
//         <div className="mt-12 text-center space-y-6">
//           <p className="text-lg text-textGray mb-6">🔍 No business found</p>
//           <a
//             href="https://business.lokalai.com/intro"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <ButtonPrimary
//               className="mt-6"
//               sizeClass="px-6 py-3 lg:px-8 lg:py-4 rounded-xl"
//               fontSize="text-sm sm:text-base lg:text-lg font-medium"
//             >
//               List your Business
//             </ButtonPrimary>
//           </a>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SectionGridAuthorBox;
